export const TableProp = Object.freeze({
    TableHeader: 'tableHeader',
    TableData: 'tableData',
    TableFooter: 'tableFooter',
});